import { useEffect, useRef, useState } from 'react';

const CHECK_INTERVAL_MS = 10_000; // 10 seconds for development, 5 minutes for production
// process.env.NODE_ENV === 'development' ? 10_000 : 5 * 60 * 1000;
const MANIFEST_URL = '/asset-manifest.json';
console.log('Version check interval:', CHECK_INTERVAL_MS, 'ms');
async function fetchMainJsHash(): Promise<string | null> {
  try {
    const res = await fetch(`${MANIFEST_URL}?_=${Date.now()}`, {
      cache: 'no-store',
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.files?.['main.js'] ?? null;
  } catch {
    return null;
  }
}

interface VersionCheckResult {
  updateAvailable: boolean;
  applyUpdate: () => void;
}

export const useVersionCheck = (): VersionCheckResult => {
  const baselineRef = useRef<string | null>(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const applyUpdate = () => window.location.reload();

  useEffect(() => {
    fetchMainJsHash().then((hash) => {
      baselineRef.current = hash;
    });
  }, []);

  useEffect(() => {
    const checkForUpdate = async () => {
      if (updateAvailable) return;
      const hash = await fetchMainJsHash();
      if (!hash || !baselineRef.current || hash === baselineRef.current) return;
      setUpdateAvailable(true);
    };

    const intervalId = window.setInterval(checkForUpdate, CHECK_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, [updateAvailable]);

  return { updateAvailable, applyUpdate };
};
